import React from 'react'
import logo from '../img/logo.png'
import react_logo from '../img/react_logo.png'
import tux_logo from '../img/linux_logo.png'
import db_logo from '../img/db_logo.png'

export const SkillPage = () => {
    return (
            <div className="mui-container z-depth-1">
                <h5>Skills</h5>
                <div className="logoblock"><img src={tux_logo} alt="Logo" id="grayscale"/><img src={db_logo} alt="Logo" id="grayscale"/><img src={logo} alt="Logo" id="grayscale"/><img src={react_logo} alt="Logo" id="grayscale"/></div>
                   <div className="row">
                        <div className="col s12 m6">
                          <div className="card blue-grey darken-2">
                              <div className="card-content white-text">
                                <span className="card-title">OS Administator</span>
                                <p>I am a very simple card. I am good at containing small bits of information.
                                I am convenient because I require little markup to use effectively.</p>
                              </div>
                          </div>
            </div>
                        <div className="col s12 m6">
                        <div className="card blue-grey darken-2">
                              <div className="card-content white-text">
                                <span className="card-title">DB Administrator</span>
                                <p>I am a very simple card. I am good at containing small bits of information.
                                I am convenient because I require little markup to use effectively.</p>
                              </div>
                          </div>
                        </div>
                        <div className="col s12 m6">
                        <div className="card blue-grey darken-1">
                              <div className="card-content white-text">
                                <span className="card-title">FrontEnd Dev</span>
                                <p>I am a very simple card. I am good at containing small bits of information.
                                I am convenient because I require little markup to use effectively.</p>
                              </div>
                          </div>
                        </div>
                        <div className="col s12 m6">
                        <div className="card blue-grey darken-1">
                              <div className="card-content white-text">
                                <span className="card-title">BackEnd Dev</span>
                                <p>I am a very simple card. I am good at containing small bits of information.
                                I am convenient because I require little markup to use effectively.</p>
                              </div>
                          </div>
                        </div>
                    </div>
            </div>
    )
}